import { isUsingDarkTheme } from '@strata/react-header';

// The snippet keeps one `window.pendo` object for the page. A new object means a new page load.
let syncedAgent = null;
let syncedVisitor = null;

const accountFor = (user) => ({
    id: user.email?.split('@')[1],
    org: 'Free Market Health',
});

const visitorFor = ({ user, role, workflowPilot }) => ({
    id: user.email,
    email: user.email,
    name: user.name,
    ...(role ? { role } : {}),
    dark_mode: isUsingDarkTheme(),
    ...(workflowPilot === undefined ? {} : { workflow_pilot: workflowPilot }),
});

export const syncPendoVisitor = ({ user, role, workflowPilot } = {}) => {
    if (!user || !window.pendo) {
        return;
    }
    const visitor = visitorFor({ user, role, workflowPilot });
    const account = accountFor(user);
    const visitorKey = JSON.stringify(visitor);
    if (syncedAgent === window.pendo && syncedVisitor === visitorKey) {
        return;
    }
    if (syncedAgent !== window.pendo) {
        window.pendo.initialize({
            apiKey: process.env.REACT_APP_PENDO_API_KEY,
            visitor,
            account,
        });
        syncedAgent = window.pendo;
        syncedVisitor = visitorKey;
        return;
    }
    window.pendo.updateOptions({ visitor, account });
    syncedVisitor = visitorKey;
};
